import type { InjectionKey } from "vue";
import type { FlexComponent } from "@/utils/render-component";
import { inject, provide, ref } from "vue";

export const compoundSlotKey = Symbol() as InjectionKey<{
  createSlot: (key: string, val: () => FlexComponent) => void;
  getSlot: (key: string) => FlexComponent | undefined;
  getSlots: () => Map<string, () => FlexComponent>;
}>;

export const useCompoundSlots = <T extends string>() => {
  type Key = T;

  const slots = ref(new Map<string, () => FlexComponent>());

  function createSlot(key: Key, val: () => FlexComponent) {
    slots.value.set(key, val);
  }

  function getSlot(key: Key) {
    return slots.value.get(key)?.();
  }

  function getSlots() {
    return slots.value;
  }

  return {
    provide: () => {
      const obj = {
        createSlot,
        getSlot,
        getSlots,
      };

      provide(compoundSlotKey, obj as any);

      return obj;
    },

    inject: () => {
      return inject(compoundSlotKey)!;
    },
  };
};
